
import Vue2Filters from 'vue2-filters'
Vue.use(Vue2Filters)

Vue.filter('capitalizeWords', function(value) {
    return value.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
});

Vue.filter('injectWhitespace', function(value) {
    return value.replace(/_/g, " ");
});

Vue.filter('truncate', function(value, maxChars) {
    let suffix = '';
    if(value.length > maxChars) {
        suffix = '...';
    }
    return value.substr(0, maxChars) + suffix;
});
